module.exports = "<div class=\"d-block\" [style.height.px]=\"heightSize\" [class.w-print]=\"printing\">\n    <canvas [id]=\"element\"></canvas>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/charts/chart-bar/chart-bar.component.html
// module id = ./src/app/components/tools/charts/chart-bar/chart-bar.component.html
// module chunks = main